import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import ShoppingImg from "../../assets/miscSvg/shopping.svg";

const useStyles = makeStyles((theme) => ({
  buyResourceContainer: {
    width: "100%",
    height: "100%",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2em",
  },

  buyResourceImg: {
    width: "35%",
    minWidth: "250px",
    height: "auto",
  },

  buyResourceMessage: {
    fontSize: "1.15em",
    textAlign: "center",
  },

  floatingButton: {
    transition: "transform 0.30s",
    "&:hover": { transform: "translateY(-5px)", },
  },
}));

const BuyResource = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();

  //  ***************
  //  ** Functions **
  //  ***************
  const handleBuyResource = () => {
    window.open("https://bestzap.com.br/", "_blank");
  };

  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.buyResourceContainer}>
      <img className={classes.buyResourceImg} src={ShoppingImg} alt="Resource not Enabled" />

      <span className={classes.buyResourceMessage}>{i18n.t("buyResource.message")}</span>

      <Button variant="contained" color="primary" onClick={handleBuyResource} className={classes.floatingButton}>
        {i18n.t("buyResource.buttons.buy")}
      </Button>
    </div>
  );
};

export default BuyResource;
